"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const RestException_1 = __importDefault(require("@rc-ex/core/lib/RestException"));
const hyperid_1 = __importDefault(require("hyperid"));
const http_status_codes_1 = require("http-status-codes");
const utils_1 = __importDefault(require("./utils"));
const version = '0.16';
const uuid = (0, hyperid_1.default)();
async function request(method, endpoint, content, queryParams, config) {
    var _a;
    const newConfig = {
        method,
        baseURL: (_a = this.wsToken) === null || _a === void 0 ? void 0 : _a.uri,
        url: endpoint,
        data: content,
        params: queryParams,
        ...config,
    };
    newConfig.headers = {
        ...newConfig.headers,
        'X-User-Agent': `${this.rc.rest.appName}/${this.rc.rest.appVersion} ringcentral-extensible/ws/${version}`,
    };
    const messageId = uuid();
    const requestBody = [
        {
            type: 'ClientRequest',
            messageId,
            method: newConfig.method,
            path: newConfig.url,
            headers: newConfig.headers,
            query: newConfig.params,
        },
    ];
    if (newConfig.data) {
        requestBody.push(newConfig.data);
    }
    await this.ws.send(JSON.stringify(requestBody));
    const [meta, body] = await utils_1.default.waitForWebSocketMessage(this.ws, (_meta) => _meta.messageId === messageId);
    const response = {
        data: body,
        status: meta.status,
        statusText: (0, http_status_codes_1.getReasonPhrase)(meta.status),
        headers: meta.headers,
        config: newConfig,
    };
    if (meta.type === 'ClientRequest'
        && meta.status >= 200
        && meta.status < 300) {
        return response;
    }
    throw new RestException_1.default(response);
}
exports.request = request;
//# sourceMappingURL=rest.js.map